export default "__VITE_ASSET__051af106__"